import React, { useContext } from 'react'

import { Context } from './TableFrame-component'

interface IProps {
    data: any
}

export const TableHorizontalRows: React.FC<IProps> = ({ data }) => {
    const { classes } = useContext(Context)

    return (
        data?.map(
            ({ value, translation, hide }, i) =>
                !!value &&
                !!value?.trim() &&
                !hide && (
                    <div className={classes.tableCardRow} key={i}>
                        <div className={classes.tableCardName}>{translation}:</div>
                        <div className={classes.tableCardValue}>{value}</div>
                    </div>
                )
        ) || false
    )
}
